import { BACKEND_ROLES } from "../constants/backendRoles";
import type { MenuItemConfig } from "../types/auth.types";

const {
  ADMIN,
  COMPANY_ADMIN,
  MANAGER,
  EXECUTIVE,
  PRE_SALES,
  HR,
  EMPLOYEE,
} = BACKEND_ROLES;

/**
 * Navigation menu definitions using exact backend role strings.
 */
export const MENU_CONFIG: MenuItemConfig[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    id: "hr",
    label: "HR",
    allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
    children: [
      {
        id: "hr-users",
        label: "Employee Master",
        path: "/hr/users",
        allowedRoles: [ADMIN, COMPANY_ADMIN, HR],
      },
    ],
  },
  {
    id: "sales",
    label: "Sales",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    id: "sales-followup",
    label: "Sales Followup",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    id: "masters",
    label: "Masters",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, PRE_SALES, EMPLOYEE],
  },
  {
    id: "reports",
    label: "Reports",
    allowedRoles: [ADMIN, COMPANY_ADMIN, MANAGER, EXECUTIVE, EMPLOYEE],
  },
  {
    id: "settings",
    label: "Settings",
    allowedRoles: [ADMIN, COMPANY_ADMIN],
    children: [
      {
        id: "company-details",
        label: "Company Details",
        path: "/company",
        allowedRoles: [ADMIN, COMPANY_ADMIN],
      },
      {
        id: "company-time-lag",
        label: "Time Lag",
        path: "/company/settings",
        allowedRoles: [ADMIN, COMPANY_ADMIN],
      },
    ],
  },
];
